module.exports = __webpack_public_path__ + "static/media/heitmanSt.5aaccb5a.png";